import type { DirectorDecision } from '@/types/messages.ts';

export interface PlacedDirectorDecisions {
  /** Made before any message on screen. */
  leading: DirectorDecision[];
  /** By message id: the decisions to draw right after that message. */
  after: Map<string, DirectorDecision[]>;
}

function targetMessageId(
  decision: DirectorDecision,
  messages: { id: string; created_at: string }[],
  shownIds: Set<string>,
): string | null {
  if (decision.message_id !== null && shownIds.has(String(decision.message_id))) {
    return String(decision.message_id);
  }
  const made = new Date(decision.created_at).getTime();
  const lastBefore = messages
    .filter((message) => new Date(message.created_at).getTime() <= made)
    .at(-1);
  return lastBefore ? String(lastBefore.id) : null;
}

/**
 * Each decision goes after the persona answer it judged. One whose answer is
 * gone or not loaded goes after the last message said before it was made.
 */
export function placeDirectorDecisions(
  messages: { id: string; created_at: string }[],
  decisions: DirectorDecision[],
): PlacedDirectorDecisions {
  const placed: PlacedDirectorDecisions = { leading: [], after: new Map() };
  const shownIds = new Set(messages.map((message) => String(message.id)));

  for (const decision of decisions) {
    const target = targetMessageId(decision, messages, shownIds);

    if (target === null) {
      placed.leading.push(decision);
      continue;
    }

    placed.after.set(target, [...(placed.after.get(target) ?? []), decision]);
  }

  return placed;
}
